module.exports = __webpack_public_path__ + "resources/img/logo_ny.0b338a2aa2e05b0aec2149421970ca2d.png";